/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Quotes_Turing_TextInputs */

const en_home_quotes_turing_text = /** @type {(inputs: Home_Quotes_Turing_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It seems probable that once the machine thinking method had started, it would not take long to outstrip our feeble powers… At some stage therefore, we should have to expect the machines to take control.`)
};

/**
* | output |
* | --- |
* | "It seems probable that once the machine thinking method had started, it would not take long to outstrip our feeble powers… At some stage therefore, we should..." |
*
* @param {Home_Quotes_Turing_TextInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_quotes_turing_text = /** @type {((inputs?: Home_Quotes_Turing_TextInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Quotes_Turing_TextInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_quotes_turing_text(inputs)
});